export default "__VITE_ASSET__BQmnHYRG__"